import React from 'react';
import { FormTextFieldWithMask } from 'components/forms/FormikFields';

const MASK = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

export function FormCnpjField({ ...others }) {
  return <FormTextFieldWithMask mask={MASK} {...others} />;
}
